import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomToastService } from 'src/app/core/services/custom-toast.service';
import { MasterService } from 'src/app/core/services/master.service';
import { LoginModel } from '../../models/shared.models';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.css',
  standalone: false,
})
export class ResetPasswordComponent {
  userdetails: any;
  togglecpass: boolean = false;
  showNewPass: boolean = false;
  passWord: string = '';
  conFirmPassWord: string = '';
  isAbleToSet: boolean = false;
  errorMsgType: string = '';
  token: string | null = '';
  loginInfo: LoginModel = new LoginModel();
  companyId: number = 0;

  constructor(
    private sharedService: SharedService,
    private router: Router,
    private master: MasterService,
    private activatedRoute: ActivatedRoute,
    private toast: CustomToastService,
  ) {}

  ngOnInit(): void {
    this.userdetails = this.master.getUserDetailFromStorage();
    this.resetPasswordValues();
    this.getToken();
  }

  toggleNewPass() {
    this.showNewPass = !this.showNewPass;
  }

  toggleCPasswordVisibility() {
    this.togglecpass = !this.togglecpass;
  }

  getBtnStatus() {
    this.isAbleToSet =
      this.loginInfo.userName && this.passWord && this.conFirmPassWord ? true : false;
    this.errorMsgType = '';
  }

  managePassword() {
    if (this.passWord != this.conFirmPassWord) {
      this.errorMsgType = 'notSame';
    } else if (this.passWord.length < 8) {
      this.errorMsgType = 'passLimit';
    } else {
      this.errorMsgType = '';
      this.resetPassword();
    }
  }

  getToken() {
    this.token = this.activatedRoute.snapshot.queryParamMap.get('token');
  }

  resetPasswordValues() {
    this.loginInfo.userName = '';
    this.passWord = '';
    this.conFirmPassWord = '';
    this.isAbleToSet = false;
    this.errorMsgType = '';
  }

  // Method for set password functionality after newly created user
  setPassword() {
    if (this.token) {
      this.loginInfo.password = this.passWord;
      this.loginInfo.token = this.token;
      this.sharedService.setPassword(this.loginInfo).subscribe(
        (res) => {
          this.toast.success('New credentials have been set up successfully!');
          this.router.navigate(['/shared/login']);
        },
        (err) => {
          const canClose = this.sharedService.getErrorMessage(err);
          this.loginInfo = new LoginModel();
          this.passWord = '';
          this.conFirmPassWord = '';
        },
      );
    } else {
      this.toast.error('Provided token is not valid for the current user.');
    }
  }

  // Method for reset password functionality
  resetPassword() {
    if (this.token) {
      this.loginInfo.password = this.passWord;
      this.loginInfo.token = this.token;
      this.sharedService.resetPassword(this.loginInfo).subscribe(
        (res) => {
          this.toast.success('New credentials have been set up successfully!');
          this.router.navigate(['/shared/login']);
        },
        (err) => {
          const canClose = this.sharedService.getErrorMessage(err);
          this.loginInfo = new LoginModel();
          this.passWord = '';
          this.conFirmPassWord = '';
        },
      );
    } else {
      this.toast.error('Provided token is not valid for the current user.');
    }
  }

  // Methods for the user login
  removeCustomPrefix(tokenData: Record<string, any>): Record<string, any> {
    const cleanedData: Record<string, any> = {};

    Object.keys(tokenData).forEach((key) => {
      const newKey = key.startsWith('custom:') ? key.replace('custom:', '') : key;
      cleanedData[newKey] = tokenData[key];
    });

    return cleanedData;
  }
}
